export const normalizeCognitoAttributeName = (attributeName, fallback = 'email') => {
  if (typeof attributeName === 'string' && attributeName.trim().length > 0) {
    return attributeName;
  }

  return fallback;
};
